import { render, staticRenderFns } from "./VendorTemplate.vue?vue&type=template&id=f4276066&"
import script from "./VendorTemplate.vue?vue&type=script&lang=js&"
export * from "./VendorTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports